'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _categoryForm = require('./category-form.component');

var _categoryForm2 = _interopRequireDefault(_categoryForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.admin.categories.categoryForm', []).component('categoryForm', _categoryForm2.default).name;


// WEBPACK FOOTER //
// ./components/app/admin/categories/category-form/category-form.module.js